
    export default 
    {
    "refresh_mask": {
        "title": "Actualizaciones de estado",
        "dec": "Por favor, actualiza la página para renovar el estado."
    }
}